<template>
  <div class="personal-page">
    <header-cmp></header-cmp>

    <section class="page-part content">
      <div class="page-inner">
        <div class="section-selection">
          <ul>
            <li
              class="selection-item"
              is="router-link"
              :to="{ name: 'inquiry' }"
            >
              询价
            </li>
            <li
              class="selection-item"
              is="router-link"
              :to="{ name: 'deliver' }"
            >
              发货
            </li>
            <li
              class="selection-item"
              is="router-link"
              :to="{ name: 'order' }"
              :class="this.status == true ? 'light' : ''"
            >
              我的订单
            </li>
            <li
              class="selection-item"
              is="router-link"
              :to="{ name: 'bill' }"
              :class="this.status1 == true ? 'light' : ''"
            >
              我的账单
            </li>
            <li
              class="selection-item"
              is="router-link"
              :to="{ name: 'flowingWater' }"
              :class="this.status2 == true ? 'light' : ''"
            >
              我的流水
            </li>
            <li
              class="selection-item"
              is="router-link"
              :to="{ name: 'cost' }"
              :class="this.status3 == true ? 'light' : ''"
            >
              费用明细
            </li>
          </ul>
        </div>

        <router-view />
      </div>
    </section>

    <section class="copyright">
      <span>©杭州享运物流 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备17007786号-2</a></span>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import HeaderCmp from '@/components/header';


export default {
  name: 'indexPage',
  data() {
    return {
      current: '',
      status:false,
      status1:false,
      status2:false,
      status3:false
    }
  },
  components: {
    HeaderCmp
  },
  created() {
    if (this.$route.query.nodump) return;
    this.$router.push({ name: 'order'});
  },
  mounted() {
    this.$utils.watchRouteGoAnchor(this);
  },
  watch: {
    '$route'() {
      this.$utils.watchRouteGoAnchor(this);
      this.status = this.$route.name == 'orderDetail'
      this.status1 = this.$route.name == 'billDetail'
      this.status2 = this.$route.name == 'flowingWaterDetail'
      this.status3 = this.$route.name == 'costDetail'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../../style/_variable";

.personal-page {
  .content {
    padding: 90px 0;
    .section-selection {
      ul {
        display: flex;
        .selection-item {
          margin-top: 10px;
          background-color: $bg-clr_lighter;
          // width: 274px;
          flex: 1;
          height: 50px;
          // display: inline-block;
          text-align: center;
          line-height: 50px;
          margin-right: -3px;
          cursor: pointer;
          transition: all 0.5s;

          &:last-child {
            margin-right: none;
          }
          &.router-link-active {
            color: white;
            background-color: $text-clr_primary;
          }
        }
      }
    }
  }
  .light {
    color: white;
    background-color: #00a7f7 !important;
  }
  .copyright {
    height: 108px;
    background-color: $bg-clr;
    text-align: center;
    span {
      line-height: 108px;
    }
  }
}
.el-button--primary {
  span {
    color: white;
  }
}
.el-select {
  .el-input__inner {
    // height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/index.vue